<template>
    <div>
        <label
            class="flex items-center cursor-pointer"
            :class="[radioClass, { 'cursor-not-allowed': disabled }]"
        >
            <input type="radio" class="hidden" :checked="isChecked" :value="value" @change="toggle">
            <svg-icon
                :type="isChecked ? 'radio-button-checked' : 'radio-button-unchecked'"
            />
            <span v-if="$slots.default" class="pl-8 font-semibold">
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon.vue";

export default {
    model: {
        prop: 'checked',
        event: 'change',
    },
    components: {
        SvgIcon,
    },
    data() {
        return {
            radioClasses: {
                checked: 'text-secondary',
                unchecked: 'text-primary hover:text-primary-80',
                disabled: 'text-primary-40',
            }
        }
    },
    props: ['checked', 'value', 'disabled', 'allowUncheck'],
    computed: {
        isChecked () {
            return this.checked === this.value;
        },
        radioClass() {
            return this.disabled ? this.radioClasses.disabled : this.isChecked ? this.radioClasses.checked : this.radioClasses.unchecked;
        }
    },
    methods: {
        toggle: function (event) {
            this.$emit('change', event.target.value)
        }
    }
}
</script>

<style scoped>
input[type='radio']:checked ~ .toggle {
    @apply bg-green border-0;

    & > svg {
        @apply opacity-100;
    }
}
</style>